export const ACCESS_CHECK_DROPDOWN_ITEM_WRAPPER_DISPLAY_NAME = 'AccessCheckDropdownItemWrapper';